import { RouteObject, Navigate } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const ContactsPage = lazy(() => import('../pages/contacts/page'));
const PrivacyPage = lazy(() => import('../pages/privacy/page'));
const TermsPage = lazy(() => import('../pages/terms/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const RecruitBenefitsPage = lazy(() => import('../pages/recruit/benefits/page'));
const RecruitJobsPage = lazy(() => import('../pages/recruit/jobs/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const ArticlesPage = lazy(() => import('../pages/articles/page'));
const NoticePage = lazy(() => import('../pages/news/notice/page'));
const EventsPage = lazy(() => import('../pages/news/events/page'));
const NewsArticlesPage = lazy(() => import('../pages/news/articles/page'));
const StoryPage = lazy(() => import('../pages/about/story/page'));
const CompetencyPage = lazy(() => import('../pages/about/competency/page'));
const HistoryPage = lazy(() => import('../pages/about/history/page'));
const PartnerPage = lazy(() => import('../pages/about/partner/page'));
const CIPage = lazy(() => import('../pages/about/ci/page'));
const PhysioLinkSDKPage = lazy(() => import('../pages/solutions/physiolink-sdk/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/recruit',
    element: <Navigate to="/recruit/benefits" replace />,
  },
  {
    path: '/recruit/benefits',
    element: <RecruitBenefitsPage />,
  },
  {
    path: '/recruit/jobs',
    element: <RecruitJobsPage />,
  },
  {
    path: '/contacts',
    element: <ContactsPage />,
  },
  {
    path: '/articles',
    element: <ArticlesPage />,
  },
  {
    path: '/news/notice',
    element: <NoticePage />,
  },
  {
    path: '/news/events',
    element: <EventsPage />,
  },
  {
    path: '/news/articles',
    element: <NewsArticlesPage />,
  },
  {
    path: '/about/story',
    element: <StoryPage />,
  },
  {
    path: '/about/competency',
    element: <CompetencyPage />,
  },
  {
    path: '/about/history',
    element: <HistoryPage />,
  },
  {
    path: '/about/people',
    element: <Navigate to="/about/story" replace />,
  },
  {
    path: '/about/partner',
    element: <PartnerPage />,
  },
  {
    path: '/about/ci',
    element: <CIPage />,
  },
  {
    path: '/solutions/physiolink-sdk',
    element: <PhysioLinkSDKPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsPage />,
  },
  {
    path: '/admin',
    element: <AdminPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
